import Header from "./Header";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

class Page extends Component {
    static propTypes = {
        pageTitle: PropTypes.string,
        showHeader: PropTypes.bool,
        history: PropTypes.object.isRequired,
    }

    static defaultProps = {
        showHeader: true,
        title: "",
    }


    render() {
        let pageClass = this.props.history.location.pathname.replace(/^\/|\/$/g, "").replace(/[^A-Za-z][-]/g, "").replace(/\/.*$/,"");                        
        return (         
            <div className="container pb-4 pb-lg-5 mb-3">				
				<Header
					currentRoute={this.props.currentRoute}
					showHeader={this.props.showHeader}
					title={this.props.title}					
				/>								
                <ErrorBoundary> 
    				<div id="main" className={pageClass}>
    					{this.props.children}
    				</div>
                </ErrorBoundary>
			</div>
            
        );
    }
}

export default withRouter(Page);